import React from 'react';
export default function NotAuthorized() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Not Authorized</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}
